<template>
<div class="pieReport">
    <div class="myChart" :id="data.id"></div>
</div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'pieReport',
    data() {
        return {
            datas: []
        }
    },
    props: ['data'],
    mounted() {
        this.drawLine()
    },
    methods: {
        drawLine() {
            this.datas = this.data.list
            const legend = []
            for (var i = 0; i < this.datas.length; i++) {
                legend[i] = this.datas[i].name
            }
            // 基于准备好的dom，初始化echarts实例
            const myChart = echarts.init(document.getElementById(this.data.id))
            // 绘制图表
            myChart.setOption({
                tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} 人"
                },
                color:this.data.color,
                legend: {
                    orient: 'vertical',
                    left: 'right',
                    data: legend,
                    formatter: function (name) {
                        var len = this.datas.length
                        for (var i = 0; i < len; i++) {
                            if (this.datas[i].name === name) {
                                return name + '：' + this.datas[i].value + '人'
                            }
                        }
                    }.bind(this)
                },
                series : [
                    {
                        name: '',
                        type: 'pie',
                        radius : '70%',
                        center: ['30%', '50%'], // 图的位置，距离左跟上的位置
                        data:this.datas,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
            //修改首次进入时图的宽度
            setTimeout(function(){
                myChart.resize();
            },200)
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        }
    },
    watch: {
        data: {
            handler: function () {
                this.drawLine()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.pieReport {
    .myChart {
        width: 100%;
        height: 300px;
    }
}
</style>
